import { AxiosResponse } from 'axios';
import { ApiResponse } from 'types';
import axios, { logAxiosError } from 'utils/axios';
import { NewProfileType, RecoverPasswordProps, UserType, RegisterUserServiceProps } from './users.types';
import { VendorType } from 'types/components/shared';

/* ────────────────────────────  Users  ──────────────────────────── */

export const getUsersListService = async ({
    idMerchant
}: {
    idMerchant?: number | string;
}): Promise<AxiosResponse<ApiResponse<UserType[]>>> => {
    try {
        return await axios.get('/loolu/api/user/searchall', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getUsersListService');
        throw err;
    }
};

export const registerUserService = async (user: RegisterUserServiceProps): Promise<AxiosResponse<ApiResponse<unknown>>> => {
    try {
        return await axios.post('/loolu/api/auth/users', user);
    } catch (err) {
        logAxiosError(err, 'registerUserService');
        throw err;
    }
};

export const getUserInfoService = async (
    idUser: number,
    idMerchant: number | string = 1
): Promise<AxiosResponse<ApiResponse<UserType[]>>> => {
    try {
        return await axios.get('/loolu/api/user/searchall', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getUserInfoService');
        throw err;
    }
};

/* ────────────────────────────  Profiles  ──────────────────────────── */

export const getProfilesService = async (idMerchant?: number | string): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.get('/loolu/api/profile/search', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getProfilesService');
        throw err;
    }
};

export const createProfileService = async (data: NewProfileType): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.post('/loolu/api/profile/save', data, {
            params: { idMerchant: data.idMerchant }
        });
    } catch (err) {
        logAxiosError(err, 'createProfileService');
        throw err;
    }
};

export const updateProfileService = async (
    data: {
        idPerfil: number;
        idStatus: boolean;
        description: string;
        menus: { id: number; read: boolean; write: boolean }[];
        type: string;
    },
    idMerchant?: number
): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.post('/loolu/api/profile/save', data, { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'updateProfileService');
        throw err;
    }
};

export const deleteMenusService = async (menus: number[], idPerfil: number, idMerchant?: number): Promise<void> => {
    try {
        await Promise.all(
            menus.map((idMenu) =>
                axios.delete('/loolu/api/profile/delete', {
                    params: { idMerchant, idMenu: `${idMenu}`, idPerfil }
                })
            )
        );
    } catch (err) {
        logAxiosError(err, 'deleteMenusServiceService');
        throw err;
    }
};

/* ─────────────────────────  Vendors / Suppliers  ───────────────────────── */

export const getVendorsService = async (idMerchant?: number): Promise<AxiosResponse<ApiResponse<VendorType[]>>> => {
    try {
        return await axios.get('/loolu/api/supplier/search', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getVendorsService');
        throw err;
    }
};

export const getVendorsAccessService = async (): Promise<AxiosResponse<any>> => {
    try {
        return await axios.get('/loolu/api/catalog/vendors/access');
    } catch (err) {
        logAxiosError(err, 'getVendorsAccessService');
        throw err;
    }
};

export const createCatalogVendorsAccessService = async (params: {
    id: number;
    action: string;
    IdPerfil: number;
    ID: number;
}): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        const { id, ...body } = params;
        return await axios.post(`/loolu/api/catalog/vendors/access/${id}`, body);
    } catch (err) {
        logAxiosError(err, 'createCatalogVendorsAccessService');
        throw err;
    }
};

/* ────────────────────────────  Approvals  ──────────────────────────── */

export const getApprovalProfilesService = async (idMerchant?: number): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.get('/loolu/api/product/approvalprofile', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getApprovalProfilesService');
        throw err;
    }
};

/* ────────────────────────────  Users (updates)  ──────────────────────────── */

export const updateUserInfoService = async (dataSend: any): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.post('/loolu/api/user/save', dataSend, {
            params: { idMerchant: dataSend.idMerchant }
        });
    } catch (err) {
        logAxiosError(err, 'updateUserInfoService');
        throw err;
    }
};

export const updateNumberService = async (props: RegisterUserServiceProps): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.patch('/loolu/api/auth/users', props);
    } catch (err) {
        logAxiosError(err, 'updateNumberService');
        throw err;
    }
};

/* ────────────────────────────  Auth / Recovery  ──────────────────────────── */

export const recoverPasswordService = async (props: RecoverPasswordProps): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.patch('/loolu/api/auth/users/recoverPassword', props);
    } catch (err) {
        logAxiosError(err, 'recoverPasswordService');
        throw err;
    }
};

/* ────────────────────────────  Menus  ──────────────────────────── */

export const getMenuPermissionsService = async (idMerchant: number): Promise<AxiosResponse<ApiResponse<any>>> => {
    try {
        return await axios.get('/loolu/api/menu/search', { params: { idMerchant } });
    } catch (err) {
        logAxiosError(err, 'getMenuPermissionsService');
        throw err;
    }
};
